import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_IPO_SUBSCRIBE_FOR_USER } from "../../../config/api";
import { getIpo } from "./getIpo";
import { getIpoSubscriptions } from "./getIpoSubscriptions";

// Debits the user's wallet. data: { user_id, mode, amount | shares } — the
// same figures that were quoted; the server re-derives the totals.
export const subscribeIpoForUser = createAsyncThunk(
  "ipos/subscribeForUser",
  async ({ id, data, callback, failed }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_IPO_SUBSCRIBE_FOR_USER(id),
        data,
      });
      toast.success(response?.data?.message || "Subscription submitted");
      dispatch(getIpo(id));
      dispatch(getIpoSubscriptions({ id }));
      callback && callback(response?.data?.data);
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed && failed();
      return rejectWithValue(error.message);
    }
  }
);
